import React, { useEffect, useState } from "react";
import NotificationPopover from "../Pages/notification/notificationPopup";
import { getAllChatNotifications, getAllNotifications } from "../services/api";
import { initializeWebSocket } from "../services/websocketConfig";
import { NotificationDto } from "../types/types";

export const Header: React.FC = () => {
  const [notifications, setNotifications] = useState<NotificationDto[]>([]);
  const [chatnotifications, setchatNotifications] = useState<NotificationDto[]>(
    []
  );

  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [chatUnreadCount, setChatUnreadCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response: NotificationDto[] = await getAllNotifications();
      if (response) {
        setNotifications(response);
        const unread = response.filter(
          (notification: NotificationDto) => !notification.viewStatus
        ).length;
        setUnreadCount(unread);
      } else {
        console.error("Failed to fetch notifications");
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchChatNotifications = async () => {
    try {
      const response: NotificationDto[] = await getAllChatNotifications();
      if (response) {
        setchatNotifications(response);
        const chatUnread = response.filter(
          (notification: NotificationDto) => !notification.viewStatus
        ).length;
        setChatUnreadCount(chatUnread);
      } else {
        console.error("Failed to fetch chat notifications");
      }
    } catch (error) {
      console.error("Error fetching chat notifications:", error);
    }
  };

  const handleMessageReceived = (notification: NotificationDto) => {

    if (!notification.viewStatus && Notification.permission === "granted") {
      const displayName =
        notification.from.firstName && notification.from.lastName
          ? `${notification.from.firstName} ${notification.from.lastName}`
          : notification.from.firstName ||
          notification.from.email ||
          "Someone";

      new Notification(`New notification from ${displayName}`, {
        body: notification.message,
        icon: notification.from.profileImage || "/favicon.ico",
      });
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchChatNotifications();

    const { cleanup } = initializeWebSocket({
      onMessageReceived: handleMessageReceived,
      onFetchNotifications: fetchNotifications,
      onFetchChatNotifications: fetchChatNotifications,
    });

    if (Notification.permission === "default") {
      Notification.requestPermission();
    }

    return () => {
      cleanup();
    };
  }, []);

  const handleNotificationsUpdate = (
    updatedNotifications: NotificationDto[]
  ) => {
    setNotifications(updatedNotifications);
    const unread = updatedNotifications.filter(
      (notification: NotificationDto) => !notification.viewStatus
    ).length;
    setUnreadCount(unread);
  };

  const handleChatNotificationsUpdate = (
    updatedChatNotifications: NotificationDto[]
  ) => {
    setchatNotifications(updatedChatNotifications);
    const chatUnread = updatedChatNotifications.filter(
      (notification: NotificationDto) => !notification.viewStatus
    ).length;
    setChatUnreadCount(chatUnread);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 relative z-[9999]">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-end items-center h-14">
          <div className="flex items-center">
            <NotificationPopover
              notifications={notifications}
              chatnotifications={chatnotifications}
              unreadCount={unreadCount}
              chatUnreadCount={chatUnreadCount}
              onNotificationsUpdate={handleNotificationsUpdate}
              onChatNotificationsUpdate={handleChatNotificationsUpdate}
              onFetchNotifications={fetchNotifications}
              onFetchchatNotifications={fetchChatNotifications}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;